<template>
    <ElementLayout>
        <template #element>
            <PostcodeLookup
                v-model="model"
                :allowManualEntry="allowManualEntry"
                :searchGuard="searchGuard"
                @addressSelected="selectAddress($event)"
                @manualEntryRequested="onManualEntryRequested"
                @lookupPostcodeRequested="onLookupPostcodeRequested"
                @clearAddress="onClearAddress"
            />
        </template>

        <template v-for="(component, slot) in elementSlots" #[slot]>
            <slot :name="slot" :el$="el$">
                <component :is="component" :el$="el$" />
            </slot>
        </template>
    </ElementLayout>
</template>

<script>
import { defineElement } from '@vueform/vueform'
import { inject } from 'vue'
import PostcodeLookup from '@/components/Form/PostCodeLookup/PostcodeLookup.vue'

export default defineElement({
    name: "PostcodeLookupElement",
    components: { PostcodeLookup },
    emits: ["addressSelected", "manualEntryRequested", "lookupPostcodeRequested", "clearAddress"],

    props: {
        allowManualEntry: {
            type: Boolean,
            default: false,
        },
        // Optional guard run before a postcode search. Given the entered
        // postcode, it returns an error message to block the search, or a
        // falsy value to allow it. The actual rule lives in the consuming
        // schema so no scheme-specific logic sits in this component.
        searchGuard: {
            type: Function,
            default: null,
        },
    },

    setup(props, { element }) {
        const vueformApi = inject('vueformApi', null)

        const selectAddress = (address) => {
            const form$ = vueformApi?.value
            element.fire('addressSelected', address, element, form$)
        }

        const onManualEntryRequested = () => {
            const form$ = vueformApi?.value
            element.fire('manualEntryRequested', element, form$)
        }

        const onLookupPostcodeRequested = () => {
            const form$ = vueformApi?.value
            element.fire('lookupPostcodeRequested', element, form$)
        }

        const onClearAddress = () => {
            const form$ = vueformApi?.value
            element.fire('clearAddress', element, form$)
        }

        return { selectAddress, onManualEntryRequested, onLookupPostcodeRequested, onClearAddress, allowManualEntry: props.allowManualEntry, searchGuard: props.searchGuard }
    }
});
</script>
